<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-19 15:39:42
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-28 17:12:26
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\cooperativeColonel\list\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="cooperation main-content-padding">
		<Panel :contentPaddingTop="12" :class="{ comingSoon: $isPlatOr(platformId, ['Sp']) }">
			<platformTab @change="handleClickTab" :showAll="false" :platformId="platformId" />
			<tempalte v-if="$isPlatOr(['Dy', 'Ks'])">
				<Search v-show="showPlatformContent" ref="search" @onSubmit="onSubmit" :platformId="platformId" />
			</tempalte>
			<div class="flex flex-just-center align-center" style="margin-top: 100px" :class="{ emptySPBox: $isPlatOr(platformId, ['Sp']) }" v-else>
				<emptyPage ref="emptyPage">
					<img slot="image" src="@/assets/public/dev-img.png" alt="" />
					<p class="fz-14 yx-color-text-regular" slot="desc">敬请期待</p>
				</emptyPage>
			</div>
		</Panel>
		<tempalte v-if="$isPlatOr(['Dy', 'Ks'])">
			<Panel v-show="showPlatformContent">
				<!-- <sort :list="sortList" @onSubmit="onSubmit" /> -->
				<div class="flex-row-align-center pos-rela">
					<i class="team-list-icon mt-2"></i>
					<div class="font-h4-medium ml-6">
						近30天数据统计 共合作
						<span class="DIN yx-color-primary">{{ statisticsObj.totalPartnerCount | formatEmpty }}</span>
						个团长
					</div>
					<div style="margin-left: 48px" class="font-h6-regular yx-color-text-regular">
						<span class="item pos-rela">
							出单团长数
							<span class="font-h4-regular DIN yx-color-text-primary">{{ statisticsObj.orderPartnerCount | formatEmpty }}</span>
						</span>
						<span class="item pos-rela">
							出单商品数
							<span class="font-h4-regular DIN yx-color-text-primary">{{ statisticsObj.productPayCount | formatEmpty }}</span>
						</span>
						<span class="item pos-rela">
							出单达人数
							<span class="font-h4-regular DIN yx-color-text-primary">{{ statisticsObj.anchorPayCount | formatEmpty }}</span>
						</span>
						<span class="item pos-rela">
							寄样数
							<span class="font-h4-regular DIN yx-color-text-primary">{{ statisticsObj.productSendSampleNum | formatEmpty }}</span>
						</span>
						<span class="item pos-rela">
							总服务费
							<span class="font-h4-regular DIN yx-color-text-primary">{{ statisticsObj.estimateServiceAmount | formatEmpty | formatPrice }}</span>
						</span>
						<span class="item pos-rela">
							总销售额
							<span class="font-h4-regular DIN yx-color-text-primary">{{ statisticsObj.payOrderGmv | formatEmpty | formatPrice }}</span>
						</span>
					</div>
				</div>
				<div class="flex flex-just-between mt-20">
					<el-button v-if="$auth.hasPermi('system:cooperativeColonel:add-edit')" type="primary" @click="showPartnerDialog()">添加团长</el-button>
					<span class="yx-color-text-placeholder font-h4-regular">以下为近30天合作数据</span>
				</div>
				<multi-table
					ref="multiTable"
					:page="pageInfo"
					:columns="columns"
					@gePartnerList="pagerList"
					@getSortList="sortChange"
					:list="list"
					:total="total"
					v-loading="loading"
				>
					<empty ref="empty" slot="empty"></empty>
				</multi-table>
				<!-- <Tab ref="Tab" @refresh="refreshList" :list="list" /> -->
				<!-- <yx-pagination
				:total="total"
				:current-page="pageInfo.page_index"
				:page-size="pageInfo.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			/> -->
			</Panel>
		</tempalte>

		<KpartnerDialog ref="KpartnerDialog" :platformId="platformId" @refresh="getList" />

		<partner-dialog ref="partnerDialog" @getList="getList" />
	</div>
</template>

<script>
import Search from './components/search';
import { getInstitutionList, queryPartnerDataTotal } from '@/api/secondColonelManage';
import { platformMixin } from '@rd/rd-ui';
import Tab from './components/tab.vue';
import { formatterDate } from '@/utils/common';
import KpartnerDialog from '../components/KpartnerDialog';
import partnerDialog from '../components/partnerDialog';
import empty from '@/views/common/empty/index.vue';
import getColumns from './columns';
import emptyPage from '@/views/common/empty/index.vue';
export default {
	name: 'cooperativeColonel',
	components: {
		Search,
		Tab,
		KpartnerDialog,
		partnerDialog,
		empty,
		emptyPage,
	},
	mixins: [platformMixin],
	data() {
		return {
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			total: 0,
			list: [],
			statisticsObj: {},
			params: {},
			sortType: '',
			columns: getColumns(this),
			loading: false,
		};
	},
	created() {
		this.startDate = formatterDate(30)[0];
		this.endDate = formatterDate(30)[1];
		this.queryPartnerDataTotal();
		this.getList();
	},
	methods: {
		onSubmit(params) {
			this.params = params;
			this.pageInfo.page_index = 1;
			this.getList();
		},
		async getList() {
			try {
				this.loading = true;
				const { params, pageInfo, platformId, sortType: sort_type } = this;
				const { list = [], page = {} } = await getInstitutionList({ ...params, ...pageInfo, platformId, sort_type });
				this.list = list.map(item => ({
					...item,
					operations: this.getButtons(item),
				}));
				this.total = `${page.item_total}`;
			} finally {
				this.loading = false;
			}
		},
		pagerList(obj) {
			const { page_index, page_size } = obj;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getList();
		},
		handleClickTab(e) {
			this.pageInfo = {
				page_index: 1,
				page_size: 20,
			};
			this.platformId = e;
			this.queryPartnerDataTotal();
			this.$refs.search.onClear();
		},
		async queryPartnerDataTotal() {
			const { startDate, endDate, platformId } = this;
			const data = await queryPartnerDataTotal({ type: platformId, ...this.params, startDate, endDate });
			this.statisticsObj = data;
		},
		showPartnerDialog() {
			const ref = {
				[dataMap.PLATFORM_DY.value]: this.$refs.partnerDialog.show,
				[dataMap.PLATFORM_KS.value]: this.$refs.KpartnerDialog.show,
				[dataMap.PLATFORM_SP.value]: this.$refs.KpartnerDialog.show,
			};
			ref[this.platformId]();
		},
		sortChange({ prop, order }) {
			this.sortType = order === 'ascending' ? prop + '_asc' : order === 'descending' ? prop + '_desc' : '';
			this.getList();
		},
		getButtons() {
			let arr = [];
			arr.push({
				label: '查看详情',
				type: 'text',
				classtype: 2,
				isShow: true,
				click: row =>
					this.$router.push({
						path: '/secondColonelManage/cooperativeColonel/detail',
						query: { id: row.team_institution_id, platformId: row.platform_id },
					}),
			});

			return arr;
		},
	},
};
</script>
<style lang="less" scoped>
.item + .item {
	margin-left: 25px;
	&::before {
		content: '';
		position: absolute;
		top: 4px;
		left: -12px;
		width: 1px;
		height: 8px;
		background-color: @color-gy5;
	}
}
</style>
